import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setModels } from '../../store/inventory/InitialFilterActions';
import { InventoryResource } from '../../types/InvetoryResource';
import { useFilteredInventoryData } from '../UseFilteredInventoryData';
import { useModels } from './UseModels';

export const useSetModels = (): void => {
  const { unfilteredData } = useFilteredInventoryData();
  const dispatch = useDispatch();
  const { allModels } = useModels();

  useEffect(() => {
    if (allModels.length === 0) {
      const models = getUniqueModelsFromInventoryData(unfilteredData);
      dispatch(setModels([...models]));
    }
  }, [unfilteredData]);

  const getUniqueModelsFromInventoryData = (inventoryData: readonly InventoryResource[]) =>
    inventoryData
      .map((inventory) => inventory.model)
      .reduce((arrayOfModels, currentModel) => {
        const exists = arrayOfModels.find((model) => model === currentModel);
        if (!exists && currentModel) {
          arrayOfModels.push(currentModel);
        }
        return arrayOfModels;
      }, [] as string[]);
};
